import React from 'react'

export default function LicencjaErorrInfo({ licencja, error }) {
  let h1 = 'Brak licencji'
  let h2 = (
    <>
      Program e-Sprawozdania Finansowe
      <br />
      można uruchomić jedynie z systemów RAKS
    </>
  )

  if (!error) {
    switch (licencja.status) {
      case '1':
        h1 = 'Wersja ewaluacyjna'
        h2 = (
          <>
            Program e-Sprawozdania Finansowe
            <br />
            można uruchomić jedynie z systemów RAKS
            <br />z pełną licencją
          </>
        )
        break
      case '2':
        h1 = 'Licencja nie zawiera e-Sprawozdań'
        h2 = (
          <>
            Program e-Sprawozdania Finansowe
            <br />
            można uruchomić jedynie z systemów RAKS
            <br />z wykupionym dostępem do e-Sprawozdań
          </>
        )
        break
      case '3':
        h1 = 'Upłynął termin bezpłatnej aktualizacji'
        h2 = (
          <>
            Program e-Sprawozdania Finansowe
            <br />
            można uruchomić jedynie z systemów RAKS
            <br />z aktualną licencją
          </>
        )
        break
      default:
        h1 = 'Błąd licencji'
        h2 = (
          <>
            Wystąpił nieoczekiwany błąd
            <br />
            podczas odczytu licencji
          </>
        )
    }
  }

  return (
    <>
      <h1>{h1}</h1>
      <h2>{h2}</h2>
    </>
  )
}
